import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/Form';
import { resetPassword, userLogin } from '../controllers/user';
import { Alert } from 'react-bootstrap';
import { useAuth } from '../components/auth/AuthProvider';
import { Link, useParams, useSearchParams } from 'react-router-dom';

function ResetPassword() {
  const [searchParams, setSearchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [valid, setValid] = useState(false);
  const [alert, setAlert] = useState();
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    document.title = 'FAMA - Nueva Contraseña';
  }, []);

  useEffect(() => {
    const trimmedPass1 = password.trim();
    const trimmedPass2 = password2.trim();
    if (trimmedPass1 && trimmedPass2) {
      if (trimmedPass1 === trimmedPass2) {
        setValid(true);
      }
      else {
        setValid(false);
      }
    }
    else {
      setValid(false);
    }
  }, [password, password2]);

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      await resetPassword(token, password);
      setAlert(<Alert variant='success'>
        <p>Se ha actualizado la contraseña correctamente.</p>
        <p><Link to={'/login'}>Iniciar sesión</Link></p>
      </Alert>);
      setSuccess(true);
    }
    catch (e) {
      console.log(e);
      if (e.status === 400) {
        setAlert(<Alert variant='danger'>El token no es válido.</Alert>);
      }
      else {
        setAlert(<Alert variant='danger'>Ocurrió un error. Por favor intenta de nuevo más tarde.</Alert>);
      }
      
    }
  }

  if (!token) {
    return <Container>
      <Row className='justify-content-md-center p-4'>
        <Col md={4}>Falta información necesaria para procesar este pedido.</Col>
      </Row>
    </Container>
  }

  return (
    <Container>
      <Row className='justify-content-md-center p-4'>
        <Col md={4}>
          <h1>Nueva contraseña</h1>
          {alert}
          <Form className='mt-4 mb-4' onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Contraseña</Form.Label>
              <Form.Control type="password" placeholder="Contraseña" value={password} onChange={e => setPassword(e.target.value)} required />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Confirma la contraseña</Form.Label>
              <Form.Control type="password" placeholder="Confirma Contraseña" value={password2} onChange={e => setPassword2(e.target.value)} required />
            </Form.Group>
            {valid && <Button variant="primary" type="submit">
              Enviar
            </Button>}
          </Form>
          <p><Link to={'/login'}>Iniciar sesión</Link></p>
          <p>¿Aún no tienes cuenta? <Link to={'/registro'}>Crea una cuenta nueva</Link>.</p>
        </Col>
      </Row>
    </Container>
  );
}

export default ResetPassword;
